export const AutomationPlatformFlowProperties = {
  ACTION_TYPE: 'hs_action_type_group',
  ACTION_TYPES: 'hs_action_types',
  AUTOMATION_FOLDER_ID: 'hs_automation_folder_id',
  BUSINESS_UNIT: 'hs_all_assigned_business_unit_ids',
  CAMPAIGN_GUIDS: 'hs_campaign_guids',
  CLASSIC_WORKFLOW_TYPE: 'hs_classic_workflow_type',
  CLASSIC_WORKFLOW_ID: 'hs_classic_workflow_id',
  CREATED_AT: 'hs_flow_created_at',
  CREATED_SOURCE_APP: 'hs_source_app',
  CREATED_USER: 'hs_flow_created_by_user_id',
  DELETED_AT: 'hs_deleted_at',
  DELETED_BY: 'hs_deleted_by',
  DELETED: 'hs_is_deleted',
  DESCRIPTION: 'hs_description',
  ENROLLED_PAST_7_DAYS: 'hs_7_day_enrollment',
  ENROLLMENT_TRIGGER: 'hs_enrollment_trigger',
  // events beta
  FLOW_ID: 'hs_flow_id',
  FOLDER_ID: 'hs_folder_id',
  IS_ENABLED: 'hs_enabled',
  IS_REFERENCED: 'hs_is_referenced',
  LAST_ACTION_EXECUTION_ERROR_TIME: 'hs_last_execution_error_time',
  LAST_ACTION_EXECUTION_TIME: 'hs_last_action_execution_date',
  NAME: 'hs_name',
  OBJECT_ID: 'hs_object_id',
  OBJECT_TYPE_ID: 'hs_object_type_id',
  REFERRER: 'hs_created_referrer',
  RISK_STATUS: 'hs_at_risk_status',
  TEAM_IDS: 'hs_all_team_ids',
  TOTAL_ENROLLED: 'hs_total_enrolled',
  UNUSED: 'hs_is_unused',
  UPDATED_AT: 'hs_flow_updated_at',
  UPDATED_USER: 'hs_flow_updated_by_user_id',
  UUID: 'hs_uuid',
  VERSION: 'hs_version',
  VISIBLE_WORKFLOWS: 'hs_visible_source_app',
  FLOW_TYPE: 'hs_flow_type',
  IS_EXTERNAL_FLOW: 'hs_is_external',
  IS_COUNTED_TOWARDS_HUB_LIMITS_USAGE: 'hs_is_counted_towards_hub_limits_usage',
  ISSUE_NOTIFICATION_ENABLED: 'hs_issue_notification_enabled',
  ENROLLMENT_NOTIFICATION_ENABLED: 'hs_enrollment_notification_enabled',
  TEAM_NOTIFICATION_RECIPIENTS: 'hs_team_notification_recipients',
  USER_NOTIFICATION_RECIPIENTS: 'hs_user_notification_recipients',
  IS_CONVERSION_REPORTING_ENABLED: 'hs_conversion_reporting_enabled'
};